if(typeof moment === 'undefined') {var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = Zz1P
// module chunks = 1